import { useEffect, useState } from "react";
import { profileImgSrc } from "../../config";
import { API_BASE_URL } from "../../config";
import "./ProffesionalsJobs.css";
import timeIco from "../../assets/employment-type-icon.svg";
import preferenceIco from "../../assets/preference-icon.svg";
import { getAuthToken } from "../../auth/auth";
import { toast, ToastContainer } from "react-toastify";

export default function ProffesionalsJobsAll() {
  const [jobs, setJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [applyLoadingId, setApplyLoadingId] = useState(null);

  const fetchJobs = async () => {
    setIsLoading(true);
    try {
      const token = getAuthToken();

      const response = await fetch(`${API_BASE_URL}/jobs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (!result.success) {
        console.error(result.message || "Failed to fetch jobs");
        setJobs([]);
        setIsLoading(false);
        return;
      }

      setJobs(result.data || []);
    } catch (error) {
      console.error("Error fetching jobs:", error);
      setJobs([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const handleApply = async (jobId) => {
    try {
      const token = getAuthToken();
      setApplyLoadingId(jobId);

      const response = await fetch(`${API_BASE_URL}/jobs/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ job_id: jobId }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        toast.error(result.message || "Failed to send application");
        setApplyLoadingId(null);
        return;
      }

      toast.success(result.message || "Application sent to admin!");

      // update local state -> mark job as applied
      setJobs((prev) =>
        prev.map((job) =>
          job.id === jobId ? { ...job, candidate_status: 5 } : job
        )
      );
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error("Network error. Please try again.");
    } finally {
      setApplyLoadingId(null);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <section id="proffesionals_jobs">
        <div className="container">
          <h1>Available Jobs</h1>

          {isLoading && <p className="loading-text">Loading jobs...</p>}

          {!isLoading && jobs.length === 0 && (
            <p className="no-jobs-text">No available jobs at the moment.</p>
          )}

          <div className="proffesionals-jobs__all">
            {!isLoading &&
              jobs.map((job) => {
                const isAssigned = job.candidate_status === 1;
                const isApplied = job.candidate_status === 5;
                const isDisabled =
                  isAssigned || isApplied || applyLoadingId === job.id;

                let buttonLabel = "Apply";
                if (applyLoadingId === job.id) buttonLabel = "Applying...";
                else if (isAssigned) buttonLabel = "Assigned";
                else if (isApplied) buttonLabel = "Applied";

                return (
                  <div className="proffesionals-jobs-single" key={job.id}>
                    <div className="proffesionals-jobs-single__img">
                      <img
                        src={job.company_avatar || profileImgSrc}
                        alt="company"
                      />
                    </div>

                    <h3>{job.company_name}</h3>

                    <div className="proffesionals-jobs-single__box">
                      <span>Job Name:</span>
                      <p>{job.title}</p>
                    </div>

                    <div className="proffesionals-jobs-single__box">
                      <span>Position:</span>
                      <p>{job.position}</p>
                    </div>

                    <div className="proffesionals-jobs-single__skills">
                      <span>Skills</span>
                      <div className="job-single__skills--wrapper">
                        {job.skills?.map((skill) => (
                          <span key={skill.id}>{skill.name}</span>
                        ))}
                      </div>
                    </div>

                    <div className="proffesionals-jobs-single__info">
                      <div className="proffesionals-jobs-single__info--single">
                        <img src={timeIco} alt="employment type" />
                        <p>{job.employment_type}</p>
                      </div>

                      <div className="proffesionals-jobs-single__info--single">
                        <img src={preferenceIco} alt="preferences" />
                        <p>{job.preferences?.map((p) => p.name).join(", ")}</p>
                      </div>
                    </div>

                    <div className="proffesionals-jobs-single__button--wrapper">
                      <button
                        disabled={isDisabled}
                        onClick={() => handleApply(job.id)}
                      >
                        {buttonLabel}
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    </>
  );
}
